module.exports = __webpack_public_path__ + "img/w19b.5e14b45c.jpg";